module.exports = __webpack_public_path__ + "static/NOI4-1c821a84267b8cbf9a5fc3c5d1f38692.png";